interface IntroSvgGradientsProps {
  uid: string;
}

export const IntroSvgGradients = ({ uid }: IntroSvgGradientsProps) => (
  <defs>
    <radialGradient id={`glow-${uid}`} cx="50%" cy="50%">
      <stop offset="0%" stopColor="var(--secondary)" stopOpacity="0.4" />
      <stop offset="70%" stopColor="var(--secondary)" stopOpacity="0" />
    </radialGradient>
    <linearGradient id={`stroke-${uid}`} x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stopColor="white" stopOpacity="0.3" />
      <stop offset="50%" stopColor="var(--secondary)" stopOpacity="0.9" />
      <stop offset="100%" stopColor="white" stopOpacity="0.3" />
    </linearGradient>
    <linearGradient id={`particle-${uid}`} x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stopColor="var(--secondary-bright)" />
      <stop offset="100%" stopColor="var(--secondary)" />
    </linearGradient>
  </defs>
);
